export default {
    data() {
        return {
        }
    },
    mounted() {
        this.initSelected();
    },
    methods: {
        // 已选配置固定
        initSelected() {
            console.log('initSelected')
            $('.mainCon').scroll(function () {
                if ($(this).scrollTop() > 140) {
                    $('.jc-form-create-selected').css({ 'position': 'fixed', 'top': '10px' });
                } else {
                    $('.jc-form-create-selected').css({ 'position': 'absolute', 'top': '30px' });
                }
            });
        },
    }
}




// WEBPACK FOOTER //
// ./src/mixins/scrollSelected.js